<div></div>
<div class="container container-space py-8">
  <div class="container-1-col">
    <h2 class="typo-h3">Delen</h2>

    <parkour-deel-details-list [blocked]="teamlid.status === 'GEBLOKKEERD'" class="block mt-5" />

    @switch (teamlid.status) {
      @case ('ACTIEF') {
        <parkour-button
          (clicked)="blokkeerClick.emit()"
          class="w-full block mt-5"
          iconAfter="block"
          variant="secondary"
        >
          Blokkeren
        </parkour-button>
      }
      @case ('GEBLOKKEERD') {
        <parkour-button
          (clicked)="activeerClick.emit()"
          class="w-full block mt-5"
          iconAfter="check"
          variant="secondary"
        >
          Activeren
        </parkour-button>
      }
    }
  </div>
</div>

<div class="mt-auto full-bleed container-space pt-6 pb-8 bg-n-200">
  <div class="container-1-col">
    <h2 class="typo-h3">Stopzetten</h2>

    <p class="mt-2">Wil je deze persoon niet meer in jouw team?</p>

    <parkour-button
      (clicked)="verwijderClick.emit()"
      class="w-full block mt-4"
      iconAfter="trash"
      variant="tertiary"
    >
      Teamlid verwijderen
    </parkour-button>
  </div>
</div>
